import React, { useState } from 'react';
import { Lock, ShieldCheck } from 'lucide-react';
import { secureFetch } from '../../utils/apiClient'; // Ensure the path is correct

const AdminLogin = ({ onLogin }) => {
  const [token, setToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // 1. Send the token to the server, NOT comparing it locally
    try {
      const response = await secureFetch('/api/admin/verify', {
        method: 'POST',
        body: JSON.stringify({ token })
      });

      // 2. Only unlock if the SERVER says it's okay
      if (response.ok) {
        localStorage.setItem('ava_admin_session', token);
        onLogin(token);
      } else {
        alert("Invalid Principal Authorization");
      }
    } catch (err) {
      console.error("Auth error:", err);
      alert("Authentication service unreachable.");
    }
  };

  return (
    <div className="min-h-screen bg-stone-950 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-stone-900 border border-stone-800 p-12 rounded-[2rem] shadow-2xl">
        <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 bg-amber-600/10 rounded-full flex items-center justify-center mb-4 border border-amber-600/20">
                <Lock className="text-amber-600" size={24} />
            </div>
          <h1 className="text-stone-100 text-xs uppercase tracking-[0.6em] font-bold">Secure Access</h1>
          <p className="text-stone-500 text-[10px] mt-2 italic">Micheal's Technical Design — Archive v3.2</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <input 
            type="password" 
            placeholder="Authorization Token"
            className="w-full bg-stone-800 border border-stone-700 rounded-xl px-4 py-4 text-stone-100 text-center tracking-[0.3em] outline-none focus:border-amber-600 transition-all"
            value={token}
            onChange={(e) => setToken(e.target.value)}
          />
          <button className="w-full bg-amber-600 hover:bg-amber-500 text-white py-4 rounded-xl text-[10px] uppercase font-bold tracking-[0.3em] transition-all flex items-center justify-center gap-2">
            <ShieldCheck size={16} /> Authenticate
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;